import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './fieldset.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

@customElement('cse-fieldset')
export class CSEFieldset extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  override render() {
    return html`
      <fieldset class="cse-fieldset">
        <slot></slot>
      </fieldset>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-fieldset': CSEFieldset
  }
}
